
 // Time-boxed offers. "Now" can be overridden for QA with ?preview_date=2026-11-12T00:00:00+05:30
// (dev builds, or any build when VITE_ALLOW_PREVIEW_DATE=true on staging).

const allowPreview =
  import.meta.env.DEV ||
  import.meta.env.VITE_ALLOW_PREVIEW_DATE === "true";

export function now() {
  if (allowPreview) {
    const p = new URLSearchParams(window.location.search).get("preview_date");

    if (p) {
      const d = new Date(p);

      if (!Number.isNaN(d.getTime())) {
        return d;
      }
    }
  }

  return new Date();
}

export function isExpired(end, at = now()) {
  return at.getTime() > end.getTime();
}

/** Whole days left, counting today; 0 once expired. */
export function daysLeft(end, at = now()) {
  const ms = end.getTime() - at.getTime();

  return ms <= 0 ? 0 : Math.ceil(ms / 86_400_000);
}
